var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystemAccesibilitat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-203.000000, -284.000000) translate(203.000000, 284.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    fill: "#A8A19B"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.955 2.7c.745 0 1.35-.604 1.35-1.35C6.305.604 5.7 0 4.955 0c-.746 0-1.35.604-1.35 1.35 0 .746.604 1.35 1.35 1.35zM7.041 10.35c-.358 1.246-1.507 2.161-2.866 2.161-1.647 0-2.986-1.339-2.986-2.985 0-1.218.735-2.267 1.784-2.73V5.53C1.255 6.047 0 7.642 0 9.526 0 11.828 1.873 13.7 4.175 13.7c1.677 0 3.123-.997 3.786-2.427l-.472-.926c-.132 0-.285.002-.448.004z",
    transform: "translate(5.260582, 3.500000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.975 11.953L9.166 8.398c-.135-.266-.407-.434-.706-.434H6.144v-.528h1.993c.2 0 .367-.104.475-.254.07-.097.12-.21.12-.34 0-.329-.266-.595-.595-.595H6.144V4.456c0-.493-.365-1.19-1.189-1.19-.657 0-1.19.533-1.19 1.19v3.88c0 .67.544 1.214 1.214 1.214h2.995l1.588 3.122c.14.275.418.434.707.434.121 0 .244-.028.359-.087.39-.198.546-.676.347-1.066z",
    transform: "translate(5.260582, 3.500000)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemAccesibilitat);
export default __webpack_public_path__ + "static/media/system-accesibilitat.e0fecce4.svg";
export { ForwardRef as ReactComponent };